import { Button, Divider, Space } from "antd";
import { config } from "process";
import { forwardRef, useEffect, useState } from "react";
import URL from "../../../server/URL";
import Server from "../../../server/Server";
import { Line } from "@ant-design/charts";

const YearOrderReport = forwardRef((props: any, ref: any) => {
    const [days, setDays] = useState<number>(7)
    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        onLoad();
    }, [days])

    const onLoad = () => {
        var request = {
            days: days ?? 7,
        };
        Server.Post(URL.YearOrder.GetYearOrderReport, request, false).then((response: any) => {
            if (response.isSuccess) {
                setData(response.data);
            }
        })
    }

    const config = {
        data,
        xField: (d: any) => d.date,
        yField: 'value',
        colorField: 'type',
        axis: {
            y: {
                labelFormatter: (v: any) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
            },
        },
        scale: { color: { range: ['#30BF78', '#F4664A'] } },
        style: {
            lineWidth: 2,
            lineDash: (data: any[]) => {
                if (data[0].type === 'register') return [4, 4];
            },
            opacity: (data: any[]) => {
                if (data[0].type !== 'register') return 0.5;
            },
        },
    };
    return <>
        <div style={{
            backgroundColor: '#fafafa', borderBottom: '1px solid #e7e7eb'
            , position: 'fixed', top: 0, zIndex: '999', width: '100%', height: '35px'
        }}>
            <span style={{ lineHeight: '32px', fontWeight: 'bold', margin: '5px' }}>
                年单保费及出单趋势图
            </span>
            <Space size={1} style={{ float: 'right', margin: '5px', lineHeight: '32px' }} split={<Divider type='vertical' />}>
                <Button type={days != 7 ? "link" : "text"} size={'small'} onClick={() => { setDays(7); }}>7天</Button>
                <Button type={days != 30 ? "link" : "text"} size={'small'} onClick={() => { setDays(30); }}>30天</Button>
                <Button type={days != 90 ? "link" : "text"} size={'small'} onClick={() => { setDays(90); }}>90天</Button>
            </Space>
        </div>
        <div style={{ marginTop: '35px', height: 'calc(100% - 35px)', overflow: 'auto' }}>
            <Line {...config} height={350} />
        </div>
    </>
})
export default YearOrderReport;